import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47be27ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "aria-label": "Site" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "",
    style: {"text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("p", null, "HOME")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "",
    style: {"text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("p", null, "THE SONGS")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "",
    style: {"text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("p", null, "THE BAND")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "",
    style: {"text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("p", null, "MEDIA")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "",
    style: {"text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("p", null, "NEWS")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "",
    style: {"text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("p", null, "BOOK US")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: "/",
          target: "_self",
          "aria-haspopup": "false"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: "the-songs",
          target: "_self",
          "aria-haspopup": "false"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: "the-band",
          target: "_self",
          "aria-haspopup": "false"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: "media",
          target: "_self",
          "aria-haspopup": "false"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: "news",
          target: "_self",
          "aria-haspopup": "false"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: "book",
          target: "_self",
          "aria-haspopup": "false"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ])
    ])
  ]))
}